<span mat-button mat-dialog-close class="right pointer">
  <i id="closeOverlay" class="far fa-times-circle"></i>
</span>
<h1 mat-dialog-title>Fatturazione</h1>
<div mat-dialog-content>

  <div class="invoice-box" #htmlPdf>
    <table cellpadding="0" cellspacing="0">
      <tr class="top_rw">
        <td colspan="2">
          <h2 style="margin: 0px">Fattura</h2>
        </td>
        <td style="width: 30%; margin-right: 10px">
          <p style="margin: 13px">Date: {{ currentDate | date: 'medium' }}</p>
        </td>
      </tr>
      <tr class="information">
        <td colspan="3">
          <table>
            <tr>
              <td colspan="2">
                <b> From: Amministrazione Deluxy</b> <br />
                {{ user?.complainEmail || "---" }}<br />
                <!-- Website: <a href="https://deluxy.it" target="_blank">Deluxy</a> -->
              </td>
              <td>
                <b> To: {{ partner?.agency || "---" }} </b><br />
                <b> Partita Iva: {{ partner?.vatCode || "---" }} </b><br />
                {{ partner?.address }}<br />
                {{ partner?.phone }}<br />
                {{ partner?.user?.email }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <table cellspacing="0px" cellpadding="2px">
            <tr class="heading">
              <td style="width: 10%">ID CONSEGNA</td>
              <td style="width: 25%">INDIRIZZO</td>
              <td style="width: 10%">DA FATTURARE</td>
              <td style="width: 10%; text-align: center">DATE</td>
              <td style="width: 15%; text-align: center">PRODOTTO</td>
              <td style="width: 15%; text-align: center">Nome Servizio</td>
              <td style="width: 10%; text-align: center">Tipo Servizio</td>
              <td style="width: 10%; text-align: center">NOTE</td>
              <td style="width: 10%; text-align: center">DISTANZA</td>
              <td style="width: 10%; text-align: center">ORE</td>
              <td style="width: 10%; text-align: center">VALORE PRODOTTO</td>
              <td style="width: 10%; text-align: center">FEE</td>
              <td style="width: 10%; text-align: center">PREZZO</td>
              <td style="width: 10%; text-align: center">PLUS / MINUS PREZZO</td>
              <td style="width: 10%; text-align: center">VALORE</td>
              <td style="width: 10%; text-align: center">VALORE + IVA</td>
              <td style="width: 10%; text-align: center">TOTALE</td>
            </tr>
            <tr class="item" *ngFor="let delivery of deliveries; let i = index;">
              <td style="width: 10%">#{{ delivery?.id }}</td>
              <td style="width: 25%">{{ delivery?.address }}</td>
              <td style="width: 10%">{{ delivery?.billable ? "YES" : "SI" }}</td>
              <td style="width: 10%; text-align: center">{{ delivery.deliveryDate | date:'dd/MM/yyyy' }}</td>
              <td style="width: 15%; text-align: center">
                <ng-container *ngIf="delivery?.deliveryProducts && delivery.deliveryProducts.length > 0">
                  <span *ngFor="let dProduct of delivery.deliveryProducts; let last = last">
                    {{ dProduct?.product?.name }} - {{ dProduct?.productVariant?.variantName }} {{ !last ? ', ' : '' }}
                  </span>
                </ng-container>
              </td>
              <td style="width: 15%; text-align: center">{{ showServiceDetails(delivery?.service)?.service?.serviceName?.toUpperCase() || "---" }}</td>
              <td style="width: 10%; text-align: center">
                {{ delivery?.serviceType | serviceName }}
              </td>
              <td style="width: 10%; text-align: center">{{ delivery?.notes  || "---" }}</td>
              <td style="width: 10%; text-align: center">{{ delivery?.distance || "---" }}</td>
              <td style="width: 10%; text-align: center">{{ delivery?.hours || "0" }}</td>
              <td style="width: 10%; text-align: center">
                <!--
                {{
                  showServiceDetails(delivery?.service)?.service?.pricingModel?.toLowerCase() === "corporate" ? delivery?.deliveryProducts[0]?.price + "€" : 
                  delivery?.productValue ? delivery?.productValue?.toFixed(2) + "€" : "0.00€" 
                }} 
                -->
                {{ commonFunctionForValues(delivery).valoreProdotto | currency:'EUR' }}
              </td>
              <td style="width: 10%; text-align: center">
                <!-- delivery.deliveryWithoutCommision ? 0 : showServiceDetails(delivery?.service)?.service?.pricingModel?.toLowerCase() === "sales" ? showServiceDetails(delivery?.service)?.price + "%"  : "---" 
                {{ 
                  showServiceDetails(delivery?.service)?.service?.pricingModel?.toLowerCase() === "sales" ? showServiceDetails(delivery?.service)?.price + "%"  : "---"
                }} 
                -->
                {{ commonFunctionForValues(delivery).fee }}%
              </td>
              <td style="width: 10%; text-align: center">
                <!-- 
                {{
                  delivery.deliveryWithoutCommision ? (0 | currency:'EUR')
                    : delivery?.billable 
                      ? delivery?.price ? delivery?.price?.toFixed(2) + "€" : "0.00€" 
                      : "0.00€"
                }}  
                {{
                  delivery?.billable 
                    ? delivery?.price ? delivery?.price?.toFixed(2) + "€" : "0.00€" 
                    : "0.00€"
                }}  
                -->
                {{ commonFunctionForValues(delivery).prezzo | currency:'EUR' }}
              </td>
              <td style="width: 10%; text-align: center">
                <!--
                {{
                  delivery?.billable 
                    ? delivery?.additionalPrice ? delivery?.additionalPrice?.toFixed(2) + "€" : "0.00€" 
                    : "0.00€"
                }}
                -->
                {{ commonFunctionForValues(delivery).plusMinusPrezzo | currency:'EUR' }}
              </td>
              <td style="width: 10%; text-align: center">
                <!--
                {{
                  delivery?.billable
                    ? showValuePrice(delivery) + '€'
                    : '0.00€'
                }} 
                -->
                {{ commonFunctionForValues(delivery).valore | currency:'EUR' }}
              </td>
              <td style="width: 10%; text-align: center">
                
                <!--
                {{
                  delivery?.billable 
                    ?  showValuePlusVat(delivery) + '€'
                    : "0.00€"
                }}
                 -->
                {{ commonFunctionForValues(delivery).valoreIva | currency:'EUR' }}
              </td>
              <td style="width: 10%; text-align: center">
                <!-- 
                {{
                  delivery?.billable
                    ? showServiceDetails(delivery?.service)?.service?.pricingModel?.toLowerCase() === "sales" ? showTotalForSales(delivery) + '€' : showValuePlusVat(delivery) + '€'
                    : "0.00€"
                }} 
                -->
                {{ commonFunctionForValues(delivery).totale | currency:'EUR' }}
              </td>
            </tr>
            <tr class="item sub-total">
              <td style="width: 15%; text-align: center" colspan="8"></td>
              <td style="width: 15%; text-align: center">Sum Totale</td>
              <td style="width: 10%; text-align: center">{{ totalWorkingHours }}</td>
              <td style="width: 10%; text-align: center">{{ totalProductValue | currency:'EUR' }}</td>
              <td style="width: 10%; text-align: center"></td>
              <td style="width: 10%; text-align: center">{{ totalPrice | currency:'EUR' }}</td>
              <td style="width: 10%; text-align: center">{{ totalPlusPrice | currency:'EUR' }}</td>
              <td style="width: 10%; text-align: center">{{ totalValue | currency:'EUR' }}</td>
              <td style="width: 10%; text-align: center">{{ totalValuePlusVat | currency:'EUR' }}</td>
              <td style="width: 10%; text-align: center">{{ lastTotal | currency:'EUR' }}</td>
            </tr>
            <tr *ngIf="!deliveries.length">
              <td style="width: 25%; text-align: center" colspan="5">No Deliveries...</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="total">
        <td colspan="8" align="right">TOTALE DA PAGARE : SUM OF SERVIZIO PREZZO (FIXED/HOURLY + PLUS PREZZO) + VAT (22% of fee) : <b> {{ totalToPayAmount?.toFixed(2) }}€ </b></td>
      </tr>
      <tr class="total">
      </tr>
      <tr class="total">
        <td colspan="3" align="right">TOTALE DA INCASSARE: PRODOTTO VALUE - (Fee% + Fee% * Vat[22%])  : <b> {{ totalToRecieveAmount.toFixed(2) }}€ </b></td>
      </tr>
    </table>
  </div>
  <div mat-dialog-actions>
    <div class="action-buttons-section">
      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="downloadInvoice()">
        Download Fattura
        <i class="ml-5 fas fa-file-download"></i>
      </button>

      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="exportInvoiceInfo()">
        Esporta
        <i class="ml-5 fas fa-file-excel"></i>
      </button>

      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="viewInvoice()">
        View Fattura
        <i class="ml-5 fas fa-eye"></i>
      </button>

      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="sendInvoice()" *ngIf="groups.includes('admin') && (historyPage === 'active')">
        Invia Fattura via E-Mail
        <i class="ml-5 fas fa-paper-plane"></i>
      </button>
      
      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="uploadOnFatture()" *ngIf="groups.includes('admin')">
        Carica su Fatture Cloud
        <i class="ml-5 fas fa-cloud-upload-alt"></i>
      </button>
    </div>
  </div>
</div>